"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = calculateRetTaxRate;
function calculateRetTaxRate(lastYearTaxRate, retTaxRate) {
  if (lastYearTaxRate == '10%' && retTaxRate == 'higher') return 12;else if (lastYearTaxRate == '10%' && retTaxRate == 'lower') return 10;
  if (lastYearTaxRate == '12%' && retTaxRate == 'higher') return 22;else if (lastYearTaxRate == '12%' && retTaxRate == 'lower') return 10;
  if (lastYearTaxRate == '22%' && retTaxRate == 'higher') return 24;else if (lastYearTaxRate == '22%' && retTaxRate == 'lower') return 12;
  if (lastYearTaxRate == '24%' && retTaxRate == 'higher') return 32;else if (lastYearTaxRate == '24%' && retTaxRate == 'lower') return 22;
  if (lastYearTaxRate == '32%' && retTaxRate == 'higher') return 35;else if (lastYearTaxRate == '32%' && retTaxRate == 'lower') return 24;
  if (lastYearTaxRate == '35%' && retTaxRate == 'higher') return 37;else if (lastYearTaxRate == '35%' && retTaxRate == 'lower') return 32;
  if (lastYearTaxRate == '37%' && retTaxRate == 'higher') return 37;else if (lastYearTaxRate == '37%' && retTaxRate == 'lower') return 35;
  return 'Error - Failed to match any conditions %';
}